import React from "react";
import { useTranslation } from "react-i18next";

const TRANSLATED_CR100_IMAGE_BY_LANG = {
    es: "https://firebasestorage.googleapis.com/v0/b/reanibex-training.appspot.com/o/images%2Fcourses%2Fcourse_3%2FCastellano%20V4.png?alt=media&token=eac845bf-19cc-4572-8afa-6623fed16301",
    eu: "https://firebasestorage.googleapis.com/v0/b/reanibex-training.appspot.com/o/images%2Fcourses%2Fcourse_3%2FEuskera%20V4.png?alt=media&token=5152e866-884d-4579-bb9e-fa82a418f80a",
    en: "https://firebasestorage.googleapis.com/v0/b/reanibex-training.appspot.com/o/images%2Fcourses%2Fcourse_3%2FIngl%C3%A9s%20V4.png?alt=media&token=0d36134f-e127-4a82-893b-d4a110703b2b",
};

const isTranslatedCR100Image = (url) => {
    if (!url) return false;

    return (
        url.includes("Castellano%20V4.png") ||
        url.includes("Euskera%20V4.png") ||
        url.includes("Ingl%C3%A9s%20V4.png")
    );
};

const MediaContainer = ({ container }) => {
    const { i18n } = useTranslation();

    switch (container.media.type) {
        case "video":
            return (
                <video width="95%" controls style={{ borderRadius: 16 }}>
                    <source src={container.media.url} type="video/mp4" />
                </video>
            );

        case "image": {
            const lang = i18n.language.split("-")[0];

            const imageUrl = isTranslatedCR100Image(container.media.url)
                ? TRANSLATED_CR100_IMAGE_BY_LANG[lang] || TRANSLATED_CR100_IMAGE_BY_LANG.es
                : container.media.url;

            return (
                <img
                    src={imageUrl}
                    alt={container.media.alt || ""}
                    style={{
                        maxHeight: container.media.maxH,
                        maxWidth: "90%",
                    }}
                />
            );
        }

        default:
            return (
                <img
                    src={container.media.url}
                    alt={container.media.alt || ""}
                    style={{
                        maxHeight: container.media.maxH,
                        maxWidth: "90%",
                    }}
                />
            );
    }
};

export default MediaContainer;